import { AbstractComponent } from "appworks/components/abstract-component";
import { Services } from "appworks/services/services";
import { RandomRangeInt } from "appworks/utils/math/random";

export class TGRFakeSymbolValueComponent extends AbstractComponent {

    protected nMax = 20000;
    protected levels: number[];
    protected valueMap = new Map([
        [1000, "GRAND"], // GRAND
        [200, "MAJOR"],  // MAJOR
        [100, "MINOR"],  // MINOR
        [50, "MINI"]     // MINI
    ]);

    public init() {
        this.levels = new Array(this.nMax)
            .fill(1000, 0, 1)
            .fill(200, 1, 7)
            .fill(100, 7, 19)
            .fill(50, 19, 39)
            .fill(20, 39, 119)
            .fill(18, 119, 279)
            .fill(15, 279, 579)
            .fill(12, 579, 979)
            .fill(10, 979, 1979)
            .fill(8, 1979, 4279)
            .fill(6, 4279, 7279)
            .fill(5, 7279, 10379)
            .fill(3, 10379, 13579)
            .fill(2, 13579, 16779)
            .fill(1, 16779, 20000);
    }

    public getRealQHSymbolId(showingamount: number): string {
        const multiplier: number = showingamount / Services.bet.getTotalStake();
        if (this.valueMap.has(multiplier)) {
            return `QH+${this.valueMap.get(multiplier)}`;
        } else {
            return `QH_${multiplier}`;
        }
    }

    public getFakeQHSymbolId(): string {
        const multiplier = this.levels[RandomRangeInt(0, this.nMax - 1)];
        if (this.valueMap.has(multiplier)) {
            return `QH+${this.valueMap.get(multiplier)}`;
        } else {
            return `QH_${multiplier}`;
        }
    }
}
